import { SUCCESS_CODES } from "#/utils/HttpStatusCodes"
// @ts-expect-error TS(7016) FIXME: Could not find a declaration file for module 'uuid... Remove this comment to see the full error message
import { v4 as uuid } from "uuid"
import { HttpErrors, StatusCodeToHttpErrorMapping, parseErrorBody } from "#/utils/HttpErrors"
import ResponseError from "#/types/responseError"

const fetchWrapper = async (url: any, options: any) => {
  const correlationId = uuid()
  // Stack traces of error following async don't show the entry point to the stack
  // So create an error with navigable stack trace just before the fetch
  const httpError = new ResponseError(null, correlationId)

  // For some reason adding headers to non v2 calls breaks things. Only
  // add to calls which are already sending headers
  if (options.headers) {
    options.headers.append("X-Request-ID", correlationId)
    options.headers.append("X-React-App-Version", __APP_VERSION__ || "local")
  }

  let response
  try {
    response = await fetch(url, options)
  } catch (caughtError) {
    // eslint-disable-next-line no-console
    console.warn(caughtError)
    // Not including options as that would be a high risk of leaking sensitive information into our logs
    httpError.message = `${caughtError.name} - ${caughtError.message} | URL: ${url}`
    httpError.name = "FetchError"
    throw httpError
  }

  if (SUCCESS_CODES.includes(response.status)) {
    return response
  }

  httpError.response = response
  httpError.statusCode = response.status

  let clientMessage = null

  if (Object.keys(StatusCodeToHttpErrorMapping).includes(response.status.toString())) {
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    httpError.name = StatusCodeToHttpErrorMapping[response.status]
    clientMessage = `URL: ${url}`
  } else {
    httpError.name = HttpErrors.UNHANDLED_STATUS_CODE
    clientMessage = `Status Code: ${response.status} | URL: ${url}`
  }

  const responseBody = await parseErrorBody(httpError)
  const serverMessage = responseBody?.message
  httpError.message = serverMessage ? `${serverMessage} (${clientMessage})` : clientMessage
  throw httpError
}

export { fetchWrapper }
